import React, { useEffect, useState } from "react";
import "./summary-page-styles.css";
import { AgGridReact } from "ag-grid-react";
import { useData } from "../../DataContext";
import axiosInstance from "../common/axios-instance.js";
import FooterContent from "../common/footer-content/footer-content.js"; // Ensure you import FooterContent
import HeaderContent from "../common/header-content/header-content.js";
import TranslationFetcher from "./../common/translation-fetcher/translation-fetcher.js";

const SummaryPage = ({ parameters, client }) => {
  const locale = parameters.locale;
  const { clients } = useData();
  const [rowData, setRowData] = useState([]);
  const formattedCustcode = parameters?.custcode
  ? parameters.custcode.charAt(0).toUpperCase() +
    parameters.custcode.slice(1).toLowerCase()
  : "";
const resultString = formattedCustcode + " Shipper Reference";

  const [colDefs] = useState([
    { headerName: resultString, field: "sref" },
    { headerName: "Pickup Date", field: "pickupDate" },
    { headerName: "Airwaybill Number", field: "shpKey" },
    { headerName: "Piece Count", field: "pieceCount" },
    { headerName: "Origin Service Area", field: "orgSrvCd" },
    { headerName: "Shipper", field: "shipperName" },
    { headerName: "Destination Service Area", field: "destSrvCd" },
    { headerName: "Consignee", field: "consignee" },
    { headerName: "Delivery Company Name", field: "deliveryCompanyName" },
    { headerName: "Delivery Status", field: "deliveryStatus" },
  ]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);  
  const { translationData, localePassed } = TranslationFetcher({ locale });
  const countryCode = translationData?.ctryCd;

  useEffect(() => {
    const fetchTrackingData = async () => {
      setLoading(true);
      setError(null);

      // Check if parameters.sref is defined and not null
      if (!parameters.sref && parameters.awb) {
          setError("Awb search is not supported in summary page.");
          setLoading(false);
          return;
      }

      const srefArray = parameters.sref.split(",").map(s => s.trim()); // Trim whitespace

      const requests = srefArray.map(sref => {
        const requestBody = {
          custcode: parameters.custcode,
          srefs: [sref], // Send each sref as an array
          locale: parameters.locale || "en",
          fromDate: parameters.fromDate,
          toDate: parameters.toDate,
          origin: parameters.origin,
          destination: parameters.destination
        };
        return axiosInstance.post("/getShipmentDetails", requestBody).then(response => {
          const data = response.data;
          // Return the shipments along with the custcode and sref
          if (data && data.shipments) {
            return data.shipments.map(shipment => ({
              ...shipment,
              custcode: parameters.custcode, // Add custcode to each shipment
              sref: sref, // Add the sref to each shipment
              pickupDate: shipment.pickupDate
                ? new Date(shipment.pickupDate).toISOString().split("T")[0] // Format date
                : null,
            }));
          } else {
            return []; // Return an empty array if no shipments
          }
        });
      });

      try {
        // Wait for all requests to complete
        const responses = await Promise.all(requests);
        const allShipments = responses.flat(); // Flatten the array of arrays

        if (allShipments.length > 0) {
          setRowData(allShipments); // Set the row data with all shipments
        } else {
          setError("No Status available.");
        }
      } catch (error) {
        console.error("Error fetching tracking data:", error);
        setError("Error fetching tracking data. Please try again."); // Set error message on failure
      } finally {
        setLoading(false);
      }
    };

    fetchTrackingData();
  }, [clients, parameters]);

  return (
    <div className="outer-body-container text-02">
      <HeaderContent toDisplayClientLogo={true} client={client} currentPage="resultsPage" locale={localePassed} countryCode={countryCode}/>
      <div className="body-content">
        <div className="column-results"></div>
        <div className="box-results">{/*column-middle*/}
          <div className="contentbody">
          <div className="bold-text">
              <p>{translationData?.translations.resultTitle}</p>
              <p>{translationData?.translations.resultDesc}</p>            
            </div>  
            {loading ? (
              <p className="text-center">Loading...</p>
            ) : error ? (
                <p className="text-center">{error}</p>
            ) : rowData.length < 1 ? (
              <p className="text-center">No Status available</p> // Display message when no shipments are found
            ) : (
              <div
                className="ag-theme-alpine"
                style={{ width: '100%' }} // Set width to 100%
              >
                <AgGridReact
                  rowData={rowData}
                  columnDefs={colDefs}
                  getRowClass={(params) =>
                    params.rowIndex % 2 === 0 ? "even-row" : "odd-row"
                  }
                  domLayout='autoHeight' // Automatically adjusts height based on rows
                />
              </div>
            )}
          </div>
        </div>
        <div className="column-results"></div>
      </div>

      <FooterContent />
    </div>
  );
};

export default SummaryPage;